import { Tab } from '@headlessui/react';
import React, { HTMLAttributeAnchorTarget } from 'react';

import { checkActivePathname } from '@/helpers/active-link-helper';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

import { Link, usePathname } from '@/i18n/routing';
import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

export type MobileNavigationItemProps = {
    icon: React.JSX.Element | string;
    activeIcon?: React.JSX.Element | string;
    title: string;
    href: string;
    target?: HTMLAttributeAnchorTarget;
    item?: string;
};

function NavigationItemMobile(props: MobileNavigationItemProps): React.JSX.Element {
    const domainConfiguration = useDomainConfiguration();
    const { track } = useAnalytics();
    const currentPath = usePathname();
    const isActive = checkActivePathname(props.href, currentPath);

    return (
        // Width comes from the equal grid column in NavigationMobile; `min-w-0` stops a long label
        // from stretching that column.
        <Tab className="min-w-0">
            <Link
                className="block w-full"
                href={props.href}
                target={props.target}
                aria-label={props.title}
                onClick={() => {
                    if (props.item) {
                        track('Navigation Item Clicked', { item: props.item });
                    }
                }}
                /*
                 * Prefetch the full page data beyond the loading.js boundaries by setting the prefetch prop to true
                 * (See: https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#2-prefetching)
                 */
                prefetch={false}>
                <div
                    className="relative flex flex-col items-center space-y-[3px] pt-[6px]"
                    style={{
                        color: isActive && domainConfiguration.style.onBackgroundColor,
                        opacity: isActive ? 1 : 0.5
                    }}>
                    <div className="flex-none">{isActive ? props.activeIcon : props.icon}</div>
                    <span className="text-body-bold-10 leading-[16px]">{props.title}</span>
                </div>
            </Link>
        </Tab>
    );
}

export default NavigationItemMobile;
